export enum ReportRowTypesEnum {
    Trade,
    Adjustment,
    Equities,
    Fees,
    Total
}
